import FormField from '@adsk/alloy-react-form-field';
import { styled } from '@adsk/nirvana-theme';

export const Wrapper = styled(FormField)`
  > div {
    > div:first-child {
      overflow: hidden;
    }
  }
`;
